import React, { useState, useEffect } from 'react';
import Sidebar from '../components/sidebar';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import axios from 'axios';

const NetworkLeadershipAcademyRedirect = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUrlAndRedirect = async () => {
      try {
        const response = await axios.get('https://api.mrcirp.com/public/network-leadership-academy');
        if (response.data && response.data[0] && response.data[0].url) {
          const url = response.data[0].url.trim();
          if (url) {
            // Abrir el enlace guardado en una nueva pestaña
            window.open(url, '_blank', 'noopener,noreferrer');
            setLoading(false);
            return;
          }
        }
        setError('No se ha configurado el enlace del Network Leadership Academy. Por favor contacta al administrador.');
        setLoading(false);
      } catch (err) {
        console.error('Error fetching URL:', err);
        setError('Error al cargar el enlace del Network Leadership Academy. Por favor intenta más tarde.');
        setLoading(false);
      }
    };

    fetchUrlAndRedirect();
  }, []);

  return (
    <Sidebar>
      <div className="container mt-4">
        <Card>
          <Card.Body className="text-center">
            {loading && (
              <>
                <Spinner animation="border" role="status" className="mb-3">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
                <p>Redirigiendo al Network Leadership Academy...</p>
              </>
            )}
            {error && (
              <Alert variant="warning">
                {error}
              </Alert>
            )}
          </Card.Body>
        </Card>
      </div>
    </Sidebar>
  );
};

export default NetworkLeadershipAcademyRedirect;

